module.exports = __webpack_public_path__ + "463f0c722a07aa2be781488e9fc88aca.woff2";